import React from "react";
import {
  Grid,
  FormControl,
  TextField,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import moment from "moment";
import CustomTextarea from "./CustomTextarea"; // Asumiendo que tienes un componente CustomTextarea
import { RequisitosTable } from "./RequisitosTable"; // Asumiendo que tienes un componente RequisitosTable

const ProcedureDetails = ({
  tipoTramiteList,
  procedureData,
  handleAutocompleteChange,
  handleMultipleAutocompleteChange,
  handleInputChange,
  handleAddressChange,
  inputValue,
  inputRef,
  estadosList,
  usuario,
  destinosList,
  requisitos,
  setReload,
  reload,
  id_expediente,
  accesoEditarExpediente,
  accesoCrearRequisito,
  accesoOpcionalRequisito,
  accesoCompletarRequisito,
  accesoEliminarRequisito,
  accesoVerificarRequisito,
  accesoRechazarRequisito,
  accesoHistorial,
  accesoPlantilla,
  oficinasList,
  isAprobado,
  isRechazado,
}) => {
  return (
    <Grid container spacing={2}>
      {/* TIPO EXPEDIENTE */}
      <Grid item xs={12} xl={5} lg={5}>
        <FormControl fullWidth>
          <Autocomplete
            size="small"
            options={tipoTramiteList}
            getOptionLabel={(option) => option.descripcion}
            disabled={!accesoEditarExpediente || isAprobado || isRechazado}
            value={
              tipoTramiteList.find(
                (item) => item.id === parseInt(procedureData.id_tramite)
              ) || null
            }
            onChange={(e, value) =>
              handleAutocompleteChange(e, value, "id_tramite")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tipo"
                variant="outlined"
                disabled={!accesoEditarExpediente || isAprobado || isRechazado}
              />
            )}
          />
        </FormControl>
      </Grid>

      {/* PLANO ANTECEDENTE */}
      <Grid item xs={12} xl={2} lg={2}>
        <TextField
          label="Plano antecedente"
          size="small"
          // disabled={true}
          name="plano_antecedente"
          value={`${procedureData.plano_antecedente || ""}`}
          onChange={(e) => handleInputChange(e, "plano_antecedente")}
          fullWidth
        />
      </Grid>

      {/* ALTA */}
      <Grid item xs={12} xl={2} lg={2}>
        <TextField
          label="Profesional solicitante"
          size="small"
          disabled={true}
          name="alta"
          value={`${procedureData.usuario_alta || ""}`}
          onChange={(e) => handleInputChange(e, "cant_uf")}
          fullWidth
        />
      </Grid>
      {/* FECHA DE ALTA */}
      <Grid item xs={12} xl={1} lg={1}>
        <TextField
          label="Fecha de alta"
          size="small"
          disabled={true}
          name="alta"
          value={`${moment(
            procedureData.alta_fec
          ).format("DD/MM/YYYY")}`}
          onChange={(e) => handleInputChange(e, "cant_uf")}
          fullWidth
        />
      </Grid>

      {/* OFICINA ACTUAL */}
      <Grid item xs={12} xl={id_expediente ? 2 : 2} lg={id_expediente ? 2 : 2}>
        <FormControl fullWidth>
        </FormControl>
      </Grid>

      {/* NÚMERO DE EXPEDIENTE */}
      <Grid item xs={12} xl={id_expediente ? 2 : 3} lg={id_expediente ? 2 : 3}>
        <TextField
          label="Número de exp"
          size="small"
          name="exp_nro"
          type="number"
          value={procedureData.exp_nro || ""}
          onChange={(e) => handleInputChange(e, "exp_nro")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* AÑO */}
      <Grid item xs={12} xl={id_expediente ? 2 : 1} lg={id_expediente ? 2 : 1}>
        <TextField
          label="Año"
          size="small"
          type="number"
          name="exp_anio"
          value={procedureData.exp_anio || ""}
          onChange={(e) => handleInputChange(e, "exp_anio")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>
      {/* CIRCUNSCRIPCIÓN */}
      <Grid item xs={12} xl={1} lg={1}>
        <FormControl fullWidth>
          <Autocomplete
            size="small"
            options={["I", "II", "III", "IV", "V"]}
            getOptionLabel={(option) => option}
            value={procedureData.circ || ""}
            onChange={(e, value) => handleInputChange({ target: { value } }, "circ")}
            renderInput={(params) => (
              <TextField {...params} label="Circunscripción" variant="outlined" />
            )}
          />
        </FormControl>
      </Grid>

      {/* SECCIÓN */}
      <Grid item xs={1}>
        <TextField
          label="Sección"
          size="small"
          name="secc"
          value={procedureData.secc || ""}
          onChange={(e) => handleInputChange(e, "secc")}
          onKeyDown={(e) => {
            const regex = /^[A-Za-z]$/;
            if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
              e.preventDefault(); // Bloquea cualquier entrada no válida
            }
          }}
          inputProps={{ maxLength: 1 }}
          fullWidth
        />
      </Grid>

      {/* OTROS CAMPOS */}
      {[
        { label: "Fr. Nº", name: "fr_nro" },
        { label: "Fr. Let", name: "fr_lt" },
        { label: "Qu. Nº", name: "q_nro" },
        { label: "Qu. Let", name: "q_lt" },
        { label: "Ch. Nº", name: "ch_nro" },
        { label: "Ch. Let", name: "ch_lt" },
        { label: "Mz. Nº", name: "mz_nro" },
        { label: "Mz. Let", name: "mz_lt" },
        { label: "Par. Nº", name: "p_nro" },
        { label: "Par. Let", name: "p_lt" },        
        { label: "SubP. Nº", name: "sp_nro" },
        { label: "SubP. Let", name: "sp_lt" },
      ].map((field, index) => (
        <Grid key={index} item xs={1}>
          <TextField
            label={field.label}
            size="small"
            name={field.name}
            value={procedureData[field.name] || ""}
            onChange={(e) => handleInputChange(e, field.name)}
            onKeyDown={(e) => {
              if (field.name.endsWith("_nro")) {
                // Permitir solo números
                const regex = /^[0-9]$/;
                if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                  e.preventDefault();
                }
              } else if (field.name.endsWith("_lt")) {
                // Permitir solo letras
                const regex = /^[a-zA-Z]$/;
                if (!regex.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                  e.preventDefault();
                }
              }
            }}
            inputProps={{ maxLength: 3 }} // Limitar a 3 caracteres
            fullWidth
          />
        </Grid>
      ))}
      {/* PARTIDA */}
      <Grid item xs={12} xl={1} lg={1}>
        <TextField
          label="Partida"
          size="small"
          name="partida"
          value={procedureData.partida || ""}
          onChange={(e) => handleInputChange(e, "partida")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* DOMICILIO */}
      <Grid item xs={12} xl={3} lg={3}>
        <TextField
          label="Domicilio"
          size="small"
          name="dir_calle"
          value={inputValue || ""}
          onChange={(e) => handleAddressChange(e, "dir_calle")}
          inputRef={inputRef}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* LOCALIDAD */}
      <Grid item xs={12} xl={2} lg={2}>
        <TextField
          label="Localidad"
          size="small"
          name="dir_loc"
          value={procedureData.dir_loc || ""}
          onChange={(e) => handleInputChange(e, "dir_loc")}
          fullWidth
          disabled={true}
        />
      </Grid>

      {/* ZONIFICACIÓN */}
      <Grid item xs={12} xl={2} lg={2}>
        <TextField
          label="Zonificación"
          size="small"
          name="zonificacion"
          value={procedureData.zonificacion || ""}
          onChange={(e) => handleInputChange(e, "zonificacion")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* SUPERFICIE DE PARCELA */}
      <Grid item xs={12} xl={2} lg={2}>
        <TextField
          label="Sup. Parcela"
          size="small"
          name="superficie_parcela"
          value={procedureData.superficie_parcela || ""}
          onChange={(e) => handleInputChange(e, "superficie_parcela")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">m²</InputAdornment>
            ),
          }}
        />
      </Grid>

      {/* FOS */}
      <Grid item xs={12} xl={1} lg={1}>
        <TextField
          label="FOS"
          size="small"
          name="fos"
          value={procedureData.fos || ""}
          onChange={(e) => handleInputChange(e, "fos")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* FOT */}
      <Grid item xs={12} xl={1} lg={1}>
        <TextField
          label="FOT"
          size="small"
          name="fot"
          value={procedureData.fot || ""}
          onChange={(e) => handleInputChange(e, "fot")}
          fullWidth
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>
      {/* DESTINO */}
      <Grid item xs={12} xl={id_expediente ? 3 : 2} lg={id_expediente ? 3 : 2}>
        <FormControl fullWidth>
          <Autocomplete
            multiple // Habilita la selección múltiple
            size="small"
            disabled={!accesoEditarExpediente || isAprobado || isRechazado}
            options={destinosList}
            name="destino"
            getOptionLabel={(option) => option.value}
            value={destinosList.filter((item) =>
              procedureData.destino?.split(",").includes(item.id.toString())
            )} // Muestra los valores seleccionados basados en la cadena de IDs
            onChange={(e, value) =>
              handleMultipleAutocompleteChange(e, value, "destino")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Destino"
                size="small"
                variant="outlined"
                disabled={!accesoEditarExpediente || isAprobado || isRechazado}
              />
            )}
          />
        </FormControl>
      </Grid>

      {/* OBSERVACIONES */}
      <Grid item xs={12} xl={12}>
        <CustomTextarea
          label="Observaciones"
          value={procedureData.obs || ""}
          onChange={(e) => handleInputChange(e, "obs")}
          name="obs"
          rows={1}
          disabled={!accesoEditarExpediente || isAprobado || isRechazado}
        />
      </Grid>

      {/* REQUISITOS */}
      <Grid
        item
        xs={12}
        md={12}
        style={{
          boxShadow: "0 3px 5px rgba(0, 0, 0, 0.2)",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "4px",
          padding: "0.2rem",
          marginTop: 10,
        }}
      >
        <RequisitosTable
          data={requisitos || []}
          disabled={isAprobado || isRechazado}
          setReload={setReload}
          reload={reload}
          usuario={usuario}
          id_expediente={id_expediente}
          oficinasList={oficinasList}
          accionAgregar={accesoCrearRequisito}
          accesoOpcionalRequisito={accesoOpcionalRequisito}
          accionCompletar={accesoCompletarRequisito}
          accionEliminar={accesoEliminarRequisito}
          accionVerificar={accesoVerificarRequisito}
          accionRechazar={accesoRechazarRequisito}
          accionHistorial={accesoHistorial}
          accionAgregarPlantilla={accesoPlantilla}
        />
      </Grid>
    </Grid>
  );
};

export default ProcedureDetails;
